











import Vue, { PropType } from 'vue';
import moment from 'moment';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';

@Component<PointTimer>({
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class PointTimer extends Vue {
  currentStaff!: StaffEntity;

  @Prop({ type: [Date, String] as PropType<moment.MomentInput> })
  to: moment.MomentInput;

  currentDatetime: Date = new Date();

  interval: number = null;

  dateExpire: any;

  get isShow(): boolean {
    let flag = false;
    const frequencyPattern = this.currentStaff?.company?.frequencyPattern;
    const sendPointType = this.currentStaff?.company?.sendPointType;
    const resetPointDay = this.currentStaff?.company?.resetPointDay;

    switch (frequencyPattern) {
      case 1:
        const lastDayOfMonth = moment().endOf('month').format('YYYY-MM-DD');
        const currentDay = moment().format('YYYY-MM-DD');
        if (lastDayOfMonth === currentDay) {
          this.dateExpire = moment().endOf('month').add(1, 'days').format('YYYY-MM-DD 00:00:00');
          flag = true;
        }
        break;
      case 2:
        if (this.currentDatetime.getDay() === 0) {
          this.dateExpire = moment().add(1, 'days').format('YYYY-MM-DD 00:00:00');
          flag = true;
        }
        break;
      case 3:
        const year = this.currentDatetime.getFullYear();
        const month = (this.currentDatetime.getMonth() + 1).toString().padStart(2, '0');
        const day = resetPointDay.toString().padStart(2, '0');
        const dateExpire = moment(`${year}-${month}-${day}`).format('YYYY-MM-DD');
        const currentDate = moment().format('YYYY-MM-DD');

        if (sendPointType === 1 && dateExpire > currentDate) {
          const date = `${year}-${month}-${day}`;
          this.dateExpire = moment(date).format('YYYY-MM-DD 00:00:00');
          flag = true;
        }
        if (sendPointType === 2) {
          if (resetPointDay === 0 && moment().day() === 6) {
            this.dateExpire = moment().endOf('week').format('YYYY-MM-DD 00:00:00');
            flag = true;
          } else if (resetPointDay === 1 && moment().day() === 0) {
            this.dateExpire = moment().add(1, 'days').format('YYYY-MM-DD 00:00:00');
            flag = true;
          } else if (moment().day() === resetPointDay - 1) {
            this.dateExpire = moment().add(1, 'days').format('YYYY-MM-DD 00:00:00');
            flag = true;
          }
        }
        break;
      default:
        break;
    }
    return flag && this.timerData[0] < 24;
  }

  mounted() {
    this.interval = setInterval(() => {
      this.currentDatetime = new Date();
    }, 1000);
  }

  destroy() {
    clearInterval(this.interval);
  }

  get timerData() {
    const secs = Math.abs(
      moment.duration(moment(this.currentDatetime).diff(moment(this.dateExpire))).asSeconds(),
    );
    const hours = Math.floor(secs / 3600);
    const minutes = Math.floor((secs - hours * 3600) / 60);
    const seconds = Math.floor(secs - (hours * 3600 + minutes * 60));
    return [hours, minutes, seconds];
  }

  get timer() {
    return this.timerData.map((n) => String(n).padStart(2, '0')).join(':');
  }
}
